/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react';
import { useNavigate } from 'react-router-dom';
import logo from 'static/common/genie_logo.png';

const Footer = () => {
  const { mq } = useTheme();
  const navigate = useNavigate();

  const footerStyle = css`
    padding: 64px 0px;
    background-color: #f9fafb;
    .container {
      width: 1056px;
      margin: 0 auto;
      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
          width: 156px;
        }
        .list {
          display: flex;
          font-size: 14px;
          font-weight: 700;
          line-height: 22px;
          color: #bdbdbd;
          li + li {
            margin-left: 46px;
          }
        }
      }

      .bottom {
        margin-top: 32px;
        font-size: 12px;
        color: #bdbdbd;
        font-weight: 400;
        line-height: 18px;
      }
    }
    ${mq.mobile} {
      padding: 64px 34px;
      .container {
        width: 100%;
        .top {
          justify-content: left;
          align-items: start;
          flex-direction: column;
          .list {
            width: 230px;
            flex-wrap: wrap;
            font-size: 12px;
            line-height: 18px;
            margin-top: 36px;
            li {
              &:nth-of-type(2),
              &:nth-of-type(4) {
                margin-left: 20px;
              }
            }
            li:nth-of-type(n + 3) {
              margin-top: 10px;
            }
            li + li {
              margin-left: 0;
            }
          }
        }
      }
    }
  `;

  return (
    <div css={footerStyle}>
      <div className="container">
        <div className="top">
          <div className="logo">
            <img src={logo} alt="logo" />
          </div>
          <ul className="list">
            <li
              onClick={() =>
                window.open('https://www.genieworks.net', '_blank')
              }
            >
              회사소개
            </li>
            <li onClick={() => navigate('/terms/1')}>몰파이 이용약관</li>
            <li onClick={() => navigate('/terms/3')}>판매 파트너 이용약관</li>
            <li onClick={() => navigate('/terms/2')}>개인정보처리방침</li>
          </ul>
        </div>
        <div className="bottom">
          (주)지니웍스 | 대표 : 이앙 | 강남구 논현로 653, 2층 | 사업자등록번호 :
          551-88-00073
          <br />
          고객센터 : 1522-2856 (평일, 10:00 ~18:00) | e-mail :
          support@genieworks.net
          <br /> ©Genieworks.Inc All Right Reserved.
        </div>
      </div>
    </div>
  );
};

export default Footer;
